import styled from 'styled-components';

export const NewBMSC = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
